<div
  #checkboxEl
  role="checkbox"
  [attr.aria-checked]="indeterminate ? 'mixed' : checked"
  [attr.aria-invalid]="invalid"
  [attr.aria-required]="required"
  [class.disabled]="isDisabled"
  tabindex="0"
  (click)="toggleCheckbox()"
  (keydown.space)="toggleCheckbox()"
  (blur)="handleOnTouch($event)"
>
  <div class="checkbox-box">
    <div></div>
    <opac-icon class="check-icon" icon="checkbox_check"></opac-icon>
    <opac-icon class="indeterminate-icon" icon="checkbox_hyphen"></opac-icon>
  </div>

  <span class="label">
    <ng-content></ng-content>

    <span *ngIf="required" class="required" aria-hidden="true">
      *
    </span>
  </span>

  <input type="hidden" [name]="name" [value]="checked">
</div>

<div class="support-text">
    <span aria-live="assertive" class="error-text" [id]="errorId">
      <ng-content select="[slot='error']"></ng-content>
    </span>
</div>
